import type { FC } from "react";
import type { RecordsSourceOption } from "../../utils";
import * as S from "../../style";
import { Icon } from "@smartsuite/react-ui/lib";
import { useTranslation } from "react-i18next";
import { Colors } from "@smartsuite/types";
import { ActionLogo } from "../ActionLogo/ActionLogo";

export const RecordsOption: FC<{
  topLabel?: string;
  option: RecordsSourceOption;
  active: boolean;
}> = ({ topLabel, option, active }) => {
  const { t } = useTranslation();

  return (
    <S.RecordsSourceOption className={active ? "hide" : ""}>
      {option.type === "add-new-find" && (
        <S.RecordsSourceOptionCreateNew>
          <S.RecordsSourceOptionLeft>
            <Icon
              size="S"
              name="plus"
              color={Colors.dGrey}
              width={16}
              height={16}
            />
          </S.RecordsSourceOptionLeft>
          <S.RecordsSourceOptionMainNew>
            {t("find-records.create-new-find")}
          </S.RecordsSourceOptionMainNew>
        </S.RecordsSourceOptionCreateNew>
      )}
      {option.type === "no-actions" && (
        <S.RecordsSourceOptionCreateNoAction>
          <S.RecordsSourceOptionMain>
            {t("find-records.no-find-records-actions")}
          </S.RecordsSourceOptionMain>
        </S.RecordsSourceOptionCreateNoAction>
      )}
      {(option.type === "trigger" || option.type === "action") && (
        <S.RecordsSourceOptionEntity>
          <S.RecordsSourceOptionEntityInner className="option-inner">
            <S.RecordsSourceOptionLeft>
              <ActionLogo option={option} />
            </S.RecordsSourceOptionLeft>
            <S.RecordsSourceOptionMain>
              <S.RecordsSourceOptionType>
                {topLabel ?? (option.type === "action" ? "Action" : "Trigger")}
              </S.RecordsSourceOptionType>
              <S.RecordsSourceOptionName>
                {option.label}
              </S.RecordsSourceOptionName>
              {option.application?.name && (
                <S.RecordsSourceOptionApplication>
                  In {option.application.name}
                </S.RecordsSourceOptionApplication>
              )}
            </S.RecordsSourceOptionMain>
          </S.RecordsSourceOptionEntityInner>
        </S.RecordsSourceOptionEntity>
      )}
    </S.RecordsSourceOption>
  );
};
